export const tenantRoutePrefix = '/accounts/:accountId/contentarea/:areaId/';
